// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class Segment {
  readonly id: string;
  readonly alternateID: string | null;
  readonly name: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.alternateID = data.alternateID === undefined ? null : data.alternateID;
    this.name = data.name === undefined ? '' : data.name;
  }

  static zero(): Segment {
    const zeroValues: ExcludeMethodsDeep<Segment> = {
      id: NIL_UUID,
      alternateID: null,
      name: '',
    };
    return new Segment(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type SegmentWireFormat = {
  id: string;
  alternateID: string | null;
  name: string;
};

type NewSegmentProps = PartialDeep<Segment, { recurseIntoArrays: true }>;
export const NewSegment: (props: NewSegmentProps) => Segment = (props) => new Segment(props);

type NewSegmentFromWireFormatProps = PartialDeep<SegmentWireFormat, { recurseIntoArrays: true }>;
export const NewSegmentFromWireFormat: (props: NewSegmentFromWireFormatProps) => Segment = (
  props,
) => new Segment(props);
